(() => {
  const key = 'revotees-recent-products';
  document.addEventListener('click', (event) => {
    const menuToggle = event.target.closest('[data-rv-menu-toggle]');
    if (!menuToggle) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    const submenu = document.getElementById(menuToggle.getAttribute('aria-controls'));
    if (!submenu) return;
    const willOpen = menuToggle.getAttribute('aria-expanded') !== 'true';
    document.querySelectorAll('[data-rv-menu-toggle]').forEach((otherToggle) => {
      const otherMenu = document.getElementById(otherToggle.getAttribute('aria-controls'));
      otherToggle.setAttribute('aria-expanded', 'false');
      const otherIcon = otherToggle.querySelector('span');
      if (otherIcon) otherIcon.textContent = '＋';
      if (otherMenu) otherMenu.hidden = true;
    });
    menuToggle.setAttribute('aria-expanded', String(willOpen));
    const icon = menuToggle.querySelector('span');
    if (icon) icon.textContent = willOpen ? '—' : '＋';
    submenu.hidden = !willOpen;
  }, true);

  const product = document.querySelector('[data-rv-product]');
  if (product) {
    try {
      const current = JSON.parse(product.dataset.rvProduct || '{}');
      const items = JSON.parse(localStorage.getItem(key) || '[]').filter((item) => item.handle !== current.handle);
      localStorage.setItem(key, JSON.stringify([current, ...items].slice(0, 12)));
    } catch (_) {}
  }
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-rv-scroll]');
    if (!trigger) return;
    const target = document.querySelector(trigger.dataset.rvScroll);
    if (target) { event.preventDefault(); target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
  });

  document.querySelectorAll('[data-rv-subject-rotator]').forEach((rotator) => {
    const slides = Array.from(rotator.querySelectorAll('[data-rv-subject-slide]'));
    if (slides.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const dots = rotator.querySelector('.rv-subject-rotator__dots');
    const interval = Math.max(3000, Number(rotator.dataset.interval) || 5000);
    let active = 0;
    let timer;

    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === active;
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      dots?.querySelectorAll('i').forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === active));
    };
    const start = () => { clearInterval(timer); timer = setInterval(() => show(active + 1), interval); };
    const stop = () => clearInterval(timer);
    slides.forEach(() => { if (dots) dots.insertAdjacentHTML('beforeend', '<i></i>'); });
    rotator.addEventListener('mouseenter', stop);
    rotator.addEventListener('mouseleave', start);
    rotator.addEventListener('focusin', stop);
    rotator.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    show(0);
    start();
  });

  document.querySelectorAll('[data-rv-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-rv-slide]'));
    const dots = carousel.querySelector('.rv-carousel-dots');
    const count = carousel.querySelector('[data-rv-count]');
    if (!slides.length) return;
    let active = 0;

    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === active;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
        slide.querySelectorAll('video').forEach((video) => isActive ? video.play().catch(() => {}) : video.pause());
      });
      if (count) count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      dots?.querySelectorAll('button').forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === active);
        dot.setAttribute('aria-pressed', String(dotIndex === active));
      });
    };

    slides.forEach((slide, index) => {
      if (!dots) return;
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Show product video ${index + 1}`);
      dot.addEventListener('click', () => show(index));
      dots.appendChild(dot);
    });
    carousel.querySelector('[data-rv-prev]')?.addEventListener('click', () => show(active - 1));
    carousel.querySelector('[data-rv-next]')?.addEventListener('click', () => show(active + 1));
    show(0);
  });

  document.querySelectorAll('[data-rv-collection]').forEach((experience) => {
    const tabs = Array.from(experience.querySelectorAll('[data-rv-tab]'));
    const panels = Array.from(experience.querySelectorAll('[data-rv-panel]'));
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      const selected = tab.dataset.rvTab;
      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
        const icon = item.querySelector('b');
        if (icon) icon.textContent = active ? '—' : '＋';
      });
      panels.forEach((panel) => {
        const active = panel.dataset.rvPanel === selected;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      experience.querySelector('.rv-collection-results')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }));
  });
})();
